import styled from '@emotion/styled';
import {forwardRef} from 'react';

import {Body} from '@/components/HotelTileLayout/components/Body';
import {Bottom} from '@/components/HotelTileLayout/components/Bottom';
import {Container} from '@/components/HotelTileLayout/components/Container';
import {Top} from '@/components/HotelTileLayout/components/Top';

export type Props = {
  imageElement: React.ReactNode;
  categoryElement: React.ReactNode;
  nameElement: React.ReactNode;
  ratingElement: React.ReactNode;
  priceElement: React.ReactNode;
  onClickHandleTracking?: () => void;
};

export const HotelTileLayout = styled(
  forwardRef<HTMLDivElement, Props>(function HotelTileLayout(
    {
      imageElement,
      categoryElement,
      nameElement,
      ratingElement,
      priceElement,
      onClickHandleTracking,
      ...restProps
    },
    ref
  ) {
    return (
      <Container {...restProps} ref={ref}>
        {imageElement}
        <Body onClick={onClickHandleTracking}>
          <Top>
            {categoryElement}
            {nameElement}
          </Top>
          <Bottom>
            {ratingElement}
            {priceElement}
          </Bottom>
        </Body>
      </Container>
    );
  })
)``;
